import { render, staticRenderFns } from "./NumbersPanel.vue?vue&type=template&id=774bc71d&scoped=true&"
import script from "./NumbersPanel.vue?vue&type=script&lang=js&"
export * from "./NumbersPanel.vue?vue&type=script&lang=js&"
import style0 from "./NumbersPanel.vue?vue&type=style&index=0&id=774bc71d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774bc71d",
  null
  
)

export default component.exports